module.exports = __webpack_public_path__ + "img/logo-sponsor.142a52d2.png";